import { Provider } from '@angular/core';
import { SessionService } from './session.service';
import { SessionRepository } from './session.repository';
import { provideSessionApiOrigin, SessionApiService } from '@isaia/session';

export function provideSession(options: { origin: string }): Provider {
  return [provideSessionApiOrigin(options.origin), SessionApiService, SessionService, SessionRepository];
}
